const DISABLE_FULL_ACCESS = 'DFA';
const GENERATE_API_KEY = 'GA';
const GENERATE_SANDBOX_KEY = 'GS';
export const CONFIRM = {
    DISABLE_FULL_ACCESS,
    GENERATE_API_KEY,
    GENERATE_SANDBOX_KEY,
};
export type ConfirmTypes = typeof CONFIRM[keyof typeof CONFIRM];

export const DATA = {
    [CONFIRM.DISABLE_FULL_ACCESS]: {
        caption: 'Disable API V2',
        content: 'Disabling API v2 will disable access and freeze all credits associated with this account. Are you sure you want to continue?',
    },
    [CONFIRM.GENERATE_API_KEY]: {
        caption: 'Generate New API Key',
        content: 'Are you sure you want to generate a new API key? This will deactivate the current API key for the client.',
    },
    [CONFIRM.GENERATE_SANDBOX_KEY]: {
        caption: 'Generate New Sandbox Key',
        content: 'Are you sure you want to generate a new API key? This will deactivate the current Sandbox key for the client.',
    },
};
